import { handleActions } from "redux-actions";

const initState = {
  isFetchingPhases: false,
  isCreatingPhase: false,
  isUpdatingPhase: false,
  isDeletingVersionPhase: false,
  isDeletedVersionPhase: false,
  isDeletingPhase: false,
  isDeletedPhase: false,
  phaseList: [],
};

const reducer = handleActions(
  {
    REQUESTED_PHASES: (state) => ({
      ...state,
      isFetchingPhases: true,
    }),
    RECEIVED_PHASES: (state, action) => {
      const newState = {
        ...state,
        isFetchingPhases: false,
      };
      newState.phaseList = action.payload.phases.sort((a, b) => {
        return a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1;
      });
      return newState;
    },

    REQUESTED_CREATE_PHASE: (state) => ({
      ...state,
      isCreatingPhase: true,
    }),
    RECEIVED_CREATE_PHASE: (state, action) => {
      const newState = {
        ...state,
        isCreatingPhase: false,
      };
      newState.phaseList.push(action.payload.phase);
      return newState;
    },

    REQUESTED_UPDATE_PHASE: (state) => ({
      ...state,
      isUpdatingPhase: true,
    }),
    RECEIVED_UPDATE_PHASE: (state, action) => {
      const newState = {
        ...state,
        isUpdatingPhase: false,
      };
      newState.phaseList.map((phase) =>
        phase.id === action.payload.phase.id ? action.payload.phase : phase
      );
      return newState;
    },

    REQUESTED_DELETE_PHASE: (state) => ({
      ...state,
      isDeletingPhase: true,
      isDeletedPhase: false,
    }),
    RECEIVED_DELETE_PHASE: (state, action) => {
      const newState = {
        ...state,
        isDeletingPhase: false,
        isDeletedPhase: true,
      };
      return newState;
    },

    REQUESTED_DELETE_VERSION_PHASE: (state) => ({
      ...state,
      isDeletingVersionPhase: true,
      isDeletedVersionPhase: false,
    }),
    RECEIVED_DELETE_VERSION_PHASE: (state, action) => {
      const newState = {
        ...state,
        isDeletingVersionPhase: false,
        isDeletedVersionPhase: true,
      };
      return newState;
    },
  },
  initState
);

export default reducer;
